import { ErrorBoundary } from '@genial/components';
import { Center } from 'native-base';
import React from 'react';

import { StatementsOptionData } from '../../../../../../../store/customerDetail/stataments/types';

interface EmptyStatementsProps {
  isLoading?: boolean;
  data?: StatementsOptionData[];
}

export const EmptyOrders: React.FC<EmptyStatementsProps> = ({ isLoading, data }) => {
  if (isLoading || (data && data.length > 0)) {
    return null;
  }

  return (
    <Center h={{ base: '300px', lg: '566px' }}>
      <ErrorBoundary
        errorIconOrIllustration="NotFoundIllustration"
        errorTitle="Nenhum resultado corresponde à sua pesquisa"
        errorMessage="Por favor, verifique o campo informado e tente novamente."
      />
    </Center>
  );
};
